export type TranslationDictionary = Record<string, unknown>;

export type TranslationLoaderFn = () => Promise<TranslationDictionary>;

export const translationLoaders = {
  en: () => import('./en.json').then((module) => module.default),
  ar: () => import('./ar.json').then((module) => module.default),
  fr: () => import('./fr.json').then((module) => module.default),
  'fr-ca': () => import('./fr-ca.json').then((module) => module.default),
  hi: () => import('./hi.json').then((module) => module.default),
} as const satisfies Record<string, TranslationLoaderFn>;

export type SupportedTranslationLang = keyof typeof translationLoaders;
